import { Avatar } from "@mui/material";

 // Hash function to generate a numeric hash from a string
 function hashString(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
      hash = hash & hash; // Convert to 32bit integer
    }
    return Math.abs(hash);
  }
  const COLORS = [
    "#F44336", // Red
    "#E91E63", // Pink
    "#9C27B0", // Purple
    "#673AB7", // Deep Purple
    "#3F51B5", // Indigo
    "#2196F3", // Blue
    "#03A9F4", // Light Blue
    "#00BCD4", // Cyan
    "#009688", // Teal
    "#4CAF50", // Green
    "#8BC34A", // Light Green
    "#CDDC39", // Lime
    "#FFC107", // Amber
    "#FF9800", // Orange
    "#FF5722", // Deep Orange
    "#795548", // Brown
    "#607D8B", // Blue Grey
  ];
  
  // Main function to get avatar color and initial
 export function getAvatar(name: string, height = 24, width = 24) {
    const hash = hashString(name);
    const color = COLORS[hash % COLORS.length];
    const initial = name.trim()[0]?.toUpperCase() || "?";
  
    return <Avatar sx={{bgcolor:color, height, width}} >{initial}</Avatar>
  }